import React, { useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import { Spinner } from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// uuid
import uuid from 'react-uuid';

// react toastify
import { toast } from 'react-toastify';

// API
import { addAdminEmailsApi } from 'utlis/Apis/Notifications_API';

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ADMIN_EMAIL_ADDED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'

function EditMode(props) {
    // props
    const {
        authState,

        notificationsData,
        setNotificationsData,

        setEditModeVisibility,
    } = props

    // states
    const [btnDisabled, setbtnDisabled] = useState(false)
    const [btnLoading, setbtnLoading] = useState(false)
    const [formValues, setFormValues] = useState([])

    // setting default form values
    useEffect(() => {
        if (notificationsData?.admin_email_address?.length) { // if default values exist
            const requiredData = notificationsData.admin_email_address.map(item => {
                return {
                    id: uuid().replaceAll("-", ""),
                    hasError: false,
                    errorMsg: "This field is required",
                    value: item
                }
            })

            setFormValues(requiredData)
        }
    }, [notificationsData])

    // email validator
    function validateEmail(value) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) { //if email is valid
            return true
        }
        return (false)
    }

    // value change
    const handleValueChange = (ev, itemId) => {
        const inpVal = ev.target.value

        let updatedData = formValues.map(item => {
            if (item.id === itemId) { // if id matches then changing value
                return {
                    ...item,
                    value: inpVal,
                    hasError: false,
                    errorMsg: ""
                }
            }
            return item
        })

        setFormValues(updatedData) // updating values

        // if (itemId) {
        //     if (validateEmail(inpVal)) { // if email is valid
        //         let updatedData = formValues.map(item => {
        //             if (item.id === itemId) { // if id matches then changing value
        //                 return {
        //                     ...item,
        //                     value: inpVal,
        //                     hasError: false,
        //                     errorMsg: ""
        //                 }
        //             }
        //             return item
        //         })

        //         setFormValues(updatedData) // updating values
        //     } else {
        //         let updatedData = formValues.map(item => {
        //             if (item.id === itemId) { // if id matches then changing value
        //                 return {
        //                     ...item,
        //                     value: inpVal,
        //                     hasError: true,
        //                     errorMsg: "Please enter a valid email address"
        //                 }
        //             }
        //             return item
        //         })

        //         setFormValues(updatedData) // updating values
        //     }
        // }
    }

    // field delete
    const handleFeleteField = (ev, itemId) => {
        ev.preventDefault()

        if (itemId) {
            const updatedData = formValues.filter(item => item.id !== itemId)

            setFormValues(updatedData) // updating values
        }
    }

    // add new email
    const handleAddNewEmail = ev => {
        ev.preventDefault()

        const newValue = {
            id: uuid().replaceAll("-", ""),
            value: ""
        }

        setFormValues([
            ...formValues,
            newValue
        ]) // setting new values
    }

    const saveEmails = () => {
        if (formValues?.length) { // if form values exist
            // btn loading
            setbtnDisabled(true)
            setbtnLoading(true)

            const emailsData = formValues.map(item => item.value)

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // network request
            addAdminEmailsApi(headers, emailsData).then(res => {
                // btn loading
                setbtnDisabled(false)
                setbtnLoading(false)

                const resData = res.data

                // if request succesfull
                if (resData && resData.success) {
                    setNotificationsData(resData.data) // setting notifications data

                    setEditModeVisibility(false) // closing edit mode

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the success message
                    toast.success(ADMIN_EMAIL_ADDED_SUCCESSFULLY, {
                        autoClose: 2500
                    })
                }

                // if request is not succesfull
                if (resData && resData.error) {

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} addAdminEmailsApi `, err.message)


                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // btn loading
                        setbtnDisabled(false)
                        setbtnLoading(false)
                    }
                })
            })

        }
    }

    // validating fields
    const validateFields = () => {
        let isValid = false
        if (formValues?.length) { // if form values exist
            formValues.forEach(item => {
                if (item.value.length) { // if all the fields has value
                    isValid = true
                } else {
                    isValid = false
                }
            })

            return isValid
        }
        return isValid
    }

    // form submit
    const handleSubmit = ev => {
        ev.preventDefault()

        if (validateFields()) { // if fields are valid
            saveEmails()
        } else {  // if fields are not valid
            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error("Please fill all the fields first", {
                autoClose: 2000
            })
        }

    }

    return (
        <div className={`page-border-box2 mb-3 mb-md-4 add-admin-email-address`}>
            <div className="pbb2-inner">
                <div className="app-header-wrapper heading-sm mb-2">
                    <p className="app-heading text-capitalize mb-2">Admin email addresses</p>
                    <p className="app-desc st-fs-14">
                        All admin notifications are sent to the specified email address. You can specify multiple addresses.
                    </p>
                </div>

                <div className="form col-12 col-lg-5">
                    {/* form fields */}
                    {
                        formValues?.length ? formValues.map((item) => (
                            <div key={item.id} className={`form-item d-flex ${item.hasError ? "has-msg msg-error" : ""}`}>
                                <div className="st-form form-sm media-body">
                                    <input
                                        type="email"
                                        value={item.value}
                                        placeholder="Email Adderss"
                                        onChange={ev => handleValueChange(ev, item.id)}
                                        className="form-control"
                                    />

                                    {
                                        // has error
                                        item.hasError ? (
                                            <div className="st-form-msg position-absolute">
                                                <p className="st-fs-12">
                                                    {item.errorMsg}
                                                </p>
                                            </div>
                                        ) : null
                                    }
                                </div>

                                {
                                    /* delete icon */
                                    (formValues.length > 1) ? ( // only show icon if fields are more than 1
                                        <div className="icon ps-2">
                                            <a
                                                href="/"
                                                className="st-round-btn st-btn-xs d-flex align-items-center justify-content-center"
                                                title="Delete Field"
                                                onClick={ev => handleFeleteField(ev, item.id)}>
                                                <FeatherIcon
                                                    icon="trash"
                                                    size="14"
                                                    className="icon"
                                                />
                                            </a>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )) : null
                    }

                    {/* text */}
                    <div className="text mb-2">
                        <p
                            className="d-inline-flex align-items-center st-text-primary st-fw-600 cursor-pointer"
                            onClick={handleAddNewEmail}>
                            <FeatherIcon
                                icon="plus"
                                size="15"
                                className="icon"
                            />
                            <span className="ms-2">Add Email Address</span>
                        </p>
                    </div>

                    {/* btn */}
                    <div className="btns d-flex pt-1">
                        <button
                            className={`st-btn st-btn-primary st-btn-sm me-2 ${btnDisabled ? "disabled" : ""}`}
                            onClick={handleSubmit}>
                            {
                                btnLoading ? (
                                    <Spinner animation="border" size="sm" />
                                ) : (
                                    "Save"
                                )
                            }
                        </button>
                        <button className="st-btn st-btn-link st-btn-sm no-min-width" onClick={ev => {
                            ev.preventDefault()

                            setEditModeVisibility(false) // enabling edit mode
                        }}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth
    };
}

const dispatchActionsToProps = dispatch => {
    return {
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditMode)